<article>
  @if (occupancyStats) {
    <section>
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Asset</th>
            <th>Mon</th>
            <th>Tue</th>
            <th>Wed</th>
            <th>Thu</th>
            <th>Fri</th>
            <th>Sat</th>
            <th>Sun</th>
          </tr>
        </thead>
        <tbody>
          @for (assetId of occupancyStats.assetIds; track assetId) {
            <tr>
              <td>{{ occupancyStats.assets[assetId].title }}</td>
              @for (day of occupancyStats.assets[assetId].dow; track day; let i = $index) {
                <td
                  [class.rating-e]="occupancyStats.assets[assetId].perc[i] !== null && occupancyStats.assets[assetId].perc[i] < 20"
                  [class.rating-d]="occupancyStats.assets[assetId].perc[i] >= 20 && occupancyStats.assets[assetId].perc[i] < 40"
                  [class.rating-c]="occupancyStats.assets[assetId].perc[i] >= 40 && occupancyStats.assets[assetId].perc[i] < 60"
                  [class.rating-b]="occupancyStats.assets[assetId].perc[i] >= 60 && occupancyStats.assets[assetId].perc[i] < 80"
                  [class.rating-a]="occupancyStats.assets[assetId].perc[i] >= 80">
                  <span [title]="day + ' minutes'">{{ occupancyStats.assets[assetId].perc[i] }}</span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </section>
  }

  <div class="rating">
    <app-rating-ae [width]="240"></app-rating-ae>
  </div>
</article>
